import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../hooks/useTheme';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-surface shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-primary hover:text-secondary">
          Arcade Games
        </Link>
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleTheme}
            className="text-white hover:text-secondary"
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? (
              // Sun icon (shows in dark mode, clicking switches to light)
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              // Moon icon (shows in light mode, clicking switches to dark)
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>
          <Link to="/" className="text-white hover:text-secondary">
            Games
          </Link>
          <a
            href="https://github.com/abaj8494/arcade"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-secondary"
          >
            GitHub
          </a>
          {user ? (
            <>
              <Link
                to="/subscribe"
                className="text-white hover:text-secondary"
                title="Manage subscription"
              >
                {user.email}
              </Link>
              <button
                onClick={handleLogout}
                className="text-white hover:text-secondary"
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="text-white hover:text-secondary">
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
